module.exports = __webpack_public_path__ + "static/tooltip.05633abc.svg";